import React from 'react';
import PropTypes from 'prop-types';
import {Label, Base} from "..";
import {Provider} from "mobx-react";
import {observable} from "mobx";

export default class Modal extends Base {

  label = observable.box('');

  constructor(props) {
    super(props);

    if (props.label) {
      this.setLabel(props.label);
    }
  }

  get closeIcon() {
    return this.props.closeIcon || '';
  }

  setLabel(label) {
    this.label.set(label);
  }

  renderBody() {
    return (
      <Provider modal={this}>
        <React.Fragment>
          {this.props.children}
        </React.Fragment>
      </Provider>
    );
  }

  renderHeader() {
    return (
      <div className="modal-header">
        <div className="modal-title">
          <Label label={this.label}/>
        </div>
        <div className="close-modal" onClick={this.handleClose.bind(this)}>
          <img src={this.closeIcon} alt="Close modal"/>
        </div>
      </div>
    );
  }

}

Modal.propTypes = {
  label:     PropTypes.string,
  children:  PropTypes.node,
  closeIcon: PropTypes.string,
};
